import { useEffect, useRef } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import aboutDogImg from "../../assets/about_dog_compress.png";
import './AboutSection.css';

function AboutSection() {
  const headingRef = useRef(null);
  const paragraphRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-slide');
        }
      },
      { threshold: 0.1 }
    );

    const elements = [headingRef.current, paragraphRef.current];
    elements.forEach(el => el && observer.observe(el));

    return () => {
      elements.forEach(el => el && observer.unobserve(el));
    };
  }, []);

  return (
    <section className="about_section_main" id="about">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <div className="about_section_left">
              <img src={aboutDogImg}
                alt="aboutDogImg" />
            </div>
          </Col>
          <Col md={6}>
            <div className="about_section_right">
              <h1 ref={headingRef}>About Samurai Dogg</h1>
              <p ref={paragraphRef}>Introducing Samurai Dogg, the fiercest new crypto. tired of weak animal coins, its here for revenge
                against cats and other weak animal coins bringing strength, loyalty, and power to the market, no more
                gimmicks just a true warrior on a mission. the era of samurai dogg has begun.</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AboutSection;
